
import { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const faqs = [
  {
    question: 'Süreç nasıl başlar?',
    answer: 'İlk görüşmede markanızı, hedeflerinizi ve beklentilerinizi dinliyoruz. Ardından size özel bir teklif ve yol haritası hazırlıyoruz. Anlaştıktan sonra keşif aşamasıyla işe başlıyoruz.',
  },
  {
    question: 'Minimum çalışma süresi var mı?',
    answer: 'Kampanya bazlı projeler minimum 4 hafta sürer. Retainer modelinde ise minimum 3 aylık anlaşma yapıyoruz. Bu süre, stratejinin oturması ve sonuç alınması için gereklidir.',
  },
  {
    question: 'Influencer\'ı kim seçiyor?',
    answer: 'Influencer seçimini birlikte yapıyoruz. Biz veri analizi ve deneyimimizle öneriler sunuyoruz, siz de marka kimliğinize uygunluğu değerlendiriyorsunuz. Nihai karar her zaman sizindir.',
  },
  {
    question: 'AI marka kimliğini bozar mı?',
    answer: 'Hayır. AI\'ı sadece hız ve varyasyon için kullanıyoruz. Tüm çıktılar marka kimliğinize uygun şekilde yönlendiriliyor ve insan kontrolünden geçiyor. AI bir araç, karar verici değil.',
  },
  {
    question: 'Üretim hızı nedir?',
    answer: 'Kampanya tipine göre değişir. Sosyal medya içerikleri için haftalık, influencer kampanyaları için 2-3 hafta, deneyim projeleri için 4-6 hafta süre öngörüyoruz. Acil durumlar için hızlandırılmış süreçler de sunuyoruz.',
  },
  {
    question: 'Raporlama nasıl yapılıyor?',
    answer: 'Aylık detaylı performans raporları sunuyoruz. Raporlarda erişim, etkileşim, dönüşüm ve ROI metrikleri yer alır. Ayrıca haftalık özet güncellemeler ve ihtiyaç halinde anlık raporlar da sağlıyoruz.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="font-serif text-5xl text-charcoal mb-16"
        >
          Sık Sorulanlar
        </motion.h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              className="border-b border-gray-200 last:border-0"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full py-6 flex items-center justify-between text-left cursor-pointer group"
              >
                <span className="font-sans font-semibold text-lg text-charcoal group-hover:text-gray-medium transition-colors pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-charcoal transition-transform flex-shrink-0`}
                ></i>
              </button>
              
              {openIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <p className="font-sans text-base text-gray-medium leading-relaxed pb-6">
                    {faq.answer}
                  </p>
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
